import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  filterLine: {
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: theme.palette.gray20.main,
    },
  },
  filterLine2: {
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.gray30.main,
    },
  },
}));

export default useStyles;
